export function parseExistingUserInfo(userRrs) {
  const usrBday = userRrs.dateNaissance && userRrs.dateNaissance.split('/')
  const birthday = !usrBday ? null : {
    day: usrBday[0],
    month: usrBday[1],
    year: usrBday[2],
    custom: `${usrBday[0]}-${usrBday[1]}-${usrBday[2]}`,
  }
  const usrLicenceDate = userRrs.datePermis && userRrs.datePermis.split('/')
  /* eslint-disable-next-line camelcase */
  const licence_date = !usrLicenceDate ? null : {
    day: usrLicenceDate[0],
    month: usrLicenceDate[1],
    year: usrLicenceDate[2],
    custom: `${usrLicenceDate[0]}-${usrLicenceDate[1]}-${usrLicenceDate[2]}`,
  }
  return {
    address: userRrs.adresse,
    civility: userRrs.civilite,
    email: userRrs.email,
    birthday,
    birthplace: userRrs.lieuNaissance,
    licence_date,
    licence_place: userRrs.lieuPermis,
    last_name: userRrs.nom,
    first_name: userRrs.prenom,
    country: userRrs.pays,
    city: userRrs.ville,
  }
}
